import React from 'react';
import DragAndDrop from '../../../../UI/DragAndDrop';

const NoviFajl = ({ setFile, file }) => {
  const handleFiles = (files) => {
    // setFormData((curr) => {
    //   return { ...curr, nazivFajla: files[0].name };
    // });
    setFile(files);
  };
  const handleUkloniFile = () => {
    setFile([]);
    // setFormData((curr) => {
    //   return { ...curr, nazivFajla: '' };
    // });
  };
  return (
    <div>
      <DragAndDrop
        handleFiles={handleFiles}
        maxFiles={5}
        addedFiles={file}
        handleRemoveFile={handleUkloniFile}
      />
    </div>
  );
};

export default NoviFajl;
